<section class="header desktop-header pull-left w-100">
  <div class="container" *ngIf="mobileMenuOpen">
    <div class="row">
      <header class="pull-left w-100">
        <div class="header-left">

          <a routerLink="/" class="logoid"><img lazyLoad="./assets/logos/otv_logo.png" (click)="setActiveMenu('home')" alt="Tarang" title="Tarang"></a>
          <nav class="d-none d-xl-block pull-left" (load)="onLoadHeaderActiveMenu()">
            <ul class="list-none padding-left-0 margin-bottom-0 pull-left w-100">
              <li *ngFor="let m of header_tabs; let i = index;" class="menu-item mr-2" (click)="menuRedirect(m, i, true)">
                <ng-container>
                  <a class="oriya-color2" id="{{m['home_link']}}"
                    [ngClass]="{'active-menu': isActiveHeaderTab(m)}">
                    {{ m['display_title'] && m['display_title'].toLowerCase() == "all" ? "home" : m['display_title']}}
                  </a>
                </ng-container>
              </li>
            </ul>
          </nav>
        </div>

        <!-- dekstop header afterLogin -->
        <div class="header-right d-none d-xl-block relative-content header-icon-set" (mouseleave)="onMouseOutbeforelogin($event)">
          <div class="search-wrap">
            <a id="searchId" (click)="showPop('search_pop')"><img alt="Search" title="Search" src="assets/tarangplus/icon_search.svg"></a>
            <a class="selected" (click)="showPop('search_pop')"><img alt="Search" title="Search"
                src="assets/images/icon_search_selected.svg"></a>
          </div>
        
            <a *ngIf="!showSubscribeButton"  [ngClass]="{'active': activeMenuString == 'plans'}" (click)="menuRedirect('plans','', true)" class="text-capitalize before_login plans login "
            >Subscribe</a>  
          <a class="text-capitalize before_login login" id="user_login" (click)="loginBasedonRegion();" (mouseleave)="onMouseOutbeforelogin($event)"
            *ngIf="!loginStatus">Login/Register</a>
            <a class="text-capitalize before_login hamberge-icon hamberge-icon-container after_login_hamberg hamberg-icon-before" 
            id="user_login" *ngIf="!loginStatus"
            [ngClass]="{'active': userAccountMenuBeforeLogin}"
           (mouseenter)="onMouseEnterBeforeLogin($event)">
            <img lazyLoad="./assets/tarangplus/icon_more_default.svg" alt="Account" title="Account">
          </a>
          <span (mouseleave)="onMouseOutbeforelogin($event)">
          <ul class="list-none margin-bottom-0 login-account-menu" *ngIf="userAccountMenuBeforeLogin">
            <li class="w-100">
              <a href="javascript:void(0)" class="menu_item oriya-color1" (click)="loginBasedonRegion();">Login/Register</a>
            </li>
            <li class="w-100">
              <a href="javascript:void(0)" class="menu_item oriya-color1">Parental Lock</a>
             <label class="switch">
                <input
                  type="checkbox"
                  id="toggleSwitch"
                  [checked]="isParentalControlEnabled"
                  (change)="onToggleChange($event)">

                <span
                  class="slider round initial-slider"
                  [ngClass]="{ 'disabled-slider': !isParentalControlEnabled }">
                </span>
              </label>

            </li>
           
          </ul>
          </span>
          <!-- for signed user section -->
          <span (mouseleave)="onMouseOut($event)">
            <a class="after_login"  *ngIf="loginStatus">
              <a (click)="showPop('my-profile_pop')">
            <span class="icon-container">
              <img lazyLoad="./assets/tarangplus/icon_castPlaceholder.svg" alt="Account" title="Account">
              </span></a>
              <span class="caret-container">
              <!-- <i class="fa fa-caret-up" aria-hidden="true" *ngIf="userAccountMenu"></i>
              <i class="fa fa-caret-down" aria-hidden="true" *ngIf="!userAccountMenu"></i> -->
              <a class="hamberge-icon hamberge-icon-container after_login_hamberg hamberg-icon-after"
               [ngClass]="{'active': userAccountMenu}" (mouseenter)="onMouseEnter($event)" (clickElsewhere)="closeAccountMenu()">
               <!-- <a class="hamberge-icon hamberge-icon-container after_login_hamberg hamberg-icon-after"
               [ngClass]="{'active': userAccountMenu}"> -->
               <!-- [ngClass]="{'active': userAccountMenu}" (mouseenter)="onMouseEnter($event)"> -->
                <img lazyLoad="./assets/tarangplus/icon_more_default.svg" alt="Account" title="Account">
              </a>
              </span>
            </a>
            <ul class="list-none margin-bottom-0 account-menu" *ngIf="userAccountMenu">
              <li class="w-100" (click)="showPop('my-profile_pop')">
                <a  class="account_det oriya-color1" id="">My Profile</a>
              </li>
               <li class="w-100">
                <a (click)="showPop('activate-tv')" class="watch_list oriya-color1" id="" style="display:block;width:100%">
                  Activate TV</a>
              </li>
              <li class="w-100">
                <a routerLink="/users/watchlist" class="watch_list oriya-color1" id="" style="display:block;width:100%"
                  (click)="closeAccountMenu()">
                  My List</a>
              </li>
              <!-- <li class=" w-100">
                <a routerLink="/users/watchlist" class="watch_list oriya-color1" id="" style="display:block;width:100%">
                  Watch Later</a>
              </li> -->
              <li class="w-100" (click)="$event.stopPropagation()">
                <a class="watch_list oriya-color1" style="display:block;width:100%">
                  Parental Lock
                  <label class="switch">
                    <input
                      type="checkbox"
                      id="toggleSwitch"
                      [checked]="isParentalControlEnabled"
                      (change)="onToggleChange($event)">
                    <span class="slider round login-slider"></span>
                  </label>
                </a>
              </li>
              
              <li class="w-100">
                <a routerLink="/plans" class="menu_item oriya-color1" (click)="onPlansMenuClick()">Plans</a>
              </li>
             
              <!-- <li class="pull-left w-100" *ngIf="continueWatchLength > 0" (click)="showPop('delete_watch')">
                <img src="./assets/tarangplus/icon_clearwatchhistory.svg">
                <a class="clear_watch_his oriya-color1 clear_watch" id="" >Clear Watch History</a>
              </li> -->
              <li class="w-100" (click)="showPop('logout_pop')">
                <a href="javascript:void(0)" class="account_url oriya-color1 logout_link"
                >Logout</a>
              </li>
            </ul>
          </span>
       
        </div>
        <div class="header-right mobile-header-right d-block d-xl-none">
          <div id="searchId" class="search-wrap" (click)="showPop('search_pop')">
            <a><img alt="Search" title="Search" src="assets/tarangplus/icon_search.svg"></a>
            <a class="selected"><img alt="Search" title="Search" src="assets/images/icon_search_selected.svg"></a>
          </div>
          <a class="text-uppercase mobile-menu-nav" (click)="mobileToggle('mobileMenu')">
            <img alt="" lazyLoad="./assets/tarangplus/icon_hamburgerMenu.svg" title="">
          </a>
        </div>
      </header>
    </div>
  </div>

  <!-- Mobile header afterlogin  -->
  <div class="mobile_slider_menu" id="navbarCollapseMobile" *ngIf="mobileMenu">
    <div class="container">
      <div class="row">
        <header class="pull-left w-100 padding-left-0 padding-right-0">
          <div class="open-logo pull-left w-100">
            <div class="pull-left w-100 padding-left-10 padding-right-10">
              <a href="/" class="pull-left logo"><img lazyLoad="./assets/logos/otv_logo.png" alt="tarangplus" title="tarangplus"></a>
              <img class="pull-right close-btn cursor-pointer" lazyLoad="./assets/images/icon_close.svg"
                (click)="closeMobileMenu()">
            </div>
          </div>
          <nav class="pull-left w-100">
            <ul class="list-none padding-left-10 padding-right-10 margin-bottom-0 pull-left w-100 scrollable-list">

              <ng-container *ngFor="let mob of header_tabs; let i = index;">
                <li (click)="menuRedirect(mob, i, true)" [ngClass]="{'active': isActiveHeaderTab(mob)}">
                  <a class="oriya-color2" id="{{mob['home_link']}}_mobile">{{mob['display_title'].toLowerCase() == "all"
                    ? "Home" : mob['display_title']}}</a>
                </li>
              </ng-container>
              <li [ngClass]="{'active': activeMenuString == 'plans'}">
                <a (click)="onPlansMenuClick(); menuRedirect('plans','', true)" class="oriya-color2" id="">Plans</a>
              </li>
              <li *ngIf="loginStatus" [ngClass]="{'active': activeMenuString == 'profile'}">
                <a (click)="showPop('my-profile_pop')" class="oriya-color2" id="">My Profile</a>
              </li>
<li *ngIf="loginStatus" [ngClass]="{'active': activeMenuString == 'watchlist'}">
  <a routerLink="/users/watchlist" class="oriya-color2" id="" (click)="closeMobileMenu()">My List</a>
</li>
              <!-- <li *ngIf="continueWatchLength > 0 && loginStatus">
                <a class="oriya-color2" id="" (click)="showPop('delete_watch')">Clear Watch History</a>
              </li> -->
              <li *ngIf="loginStatus" [ngClass]="{'active': activeMenuString == 'tv'}">
                <a (click)="showPop('activate-tv')" class="oriya-color2" id="">Activate TV</a>
              </li>
              <li  *ngIf="loginStatus" class="pull-left w-100">
                <a href="javascript:void(0)" class="account_url oriya-color2 logout_link"
                (click)="showPop('logout_pop')">Logout</a>
              </li>          
              <li  *ngIf="!loginStatus" class="text-center">
                <div class="w-full"  style="display:flex; flex-direction:column; width: 100%;margin-right: 10px; ">
                <a class="text-uppercase before_login login" id="user_login"  (click)="loginBasedonRegion()"
                >sign in</a>
                </div>
              </li>            
            </ul>
          </nav>
        </header>
      </div>
    </div>
  </div>

  <!-- Profile Menu -->
  <div class="mobile_slider_menu" id="navbarCollapseAccount" *ngIf="profileMenu">
    <div class="container">
      <div class="row">
        <header class="pull-left w-100 padding-left-0 padding-right-0">
          <div class="open-logo pull-left w-100">
            <div class="pull-left w-100 padding-left-10 padding-right-10">
              <a href="/" class="pull-left"><img lazyLoad="./assets/logos/otv_logo.png" alt="tarangplus" title="tarangplus"></a>
              <i class="fa fa-times pull-right" aria-hidden="true" (click)="closeMobileMenu()"></i>
            </div>
          </div>
          <nav class="pull-left w-100 padding-left-10 padding-right-10">
            <ul class="list-none padding-left-0 margin-bottom-0 pull-left w-100">
              <li class="pull-left w-100"><a (click)="showPop('acc_details', 'accountDetailsForm')"
                  class="account_det oriya-color1" id="">Account
                  Details</a></li>
              <li class="pull-left w-100"><a routerLink="/users/watchlist" class="watch_list oriya-color1"
                  id="" (click)="closeMobileMenu()">Watchlist</a>
              </li>
              <li class="pull-left w-100" *ngIf="continueWatchLength > 0"><a
                  class="clear_watch_his oriya-color1 clear_watch" id="" (click)="showPop('delete_watch')">Clear Watch History</a></li>
              <li class="pull-left w-100"><a href="javascript:void(0)" class="account_url oriya-color1 logout_link"
                  (click)="showPop('logout_pop')">Logout</a></li>
            </ul>
          </nav>
        </header>
      </div>
    </div>
  </div>

</section>


<!-- dangal-sign-in pop-up starts /mobile number-->
<div class="modal model-overflow cdk-overlay-dark-backdrop" id="signin_pop">
  <div class="modal-dialog">
    <div class="modal-content user_flow otp-sign-in">

      <div class="modal-header border-0 padding-left-24 padding-right-24 padding-top-13 padding-bottom-15 flex flex-items-center flex-space-between">
        <div class="w-100">
          <p class="font-normal font-mbold font-size4 oriya-color6 margin-bottom-10 centered-text">Login</p>
          <p class="oriya-color2 font-size2 font-mbold font-normal m-0" target="blank"> Will be signed in using OTP </p>
        </div>
        <!-- <img lazyLoad="./assets/images/icon_close.svg" alt="" title="" id="signin_close"
          (click)="closePop('loginform');"> -->
      </div>
      <div class="login-group-button">
        <!-- <button [disabled]="showLoginOTP" 
        (click)="onClickSendOtpToMobile(userMobileLogin.get('sign_in_userid').value)"
        class="social-media-btn width-15"
        matSuffix>Google</button> -->
        <button class="social-media-btn width-15 facebook-btn" (click)="signInWithGoogle()">
          <img lazyLoad = "./assets/tarangplus/icon_google.svg" class="google-icon">
          <span class="signin_with_google">Continue with Google</span></button>
        <!-- <button [disabled]="showLoginOTP" 
        (click)="onClickSendOtpToMobile(userMobileLogin.get('sign_in_userid').value)"
        class="social-media-btn width-15"
        matSuffix>Whatsaap</button> -->
      </div>



      <div class="login-group-button">
        <button class="social-media-btn width-15 facebook-btn" (click)="signInWithFacebook()">
          <img lazyLoad = "./assets/tarangplus/facebook.svg" class="fb-icon">
          <span class="signin_with_google">Login with Facebook</span></button>
      </div>
      <div class="button-divider">
        <p class="oriya-color2 font-size2 font-mbold font-normal m-0" target="blank"> ------ Or ------ </p>
      </div>


        <div class="toggle-container">
          <button
            class="toggle-btn"
            [class.active]="loginTypes === 'email'"
            (click)="setLoginType('email')">
            Email
          </button>
          <button
            class="toggle-btn"
            [class.active]="loginTypes === 'mobile'"
            (click)="setLoginType('mobile')">
            Mobile
          </button>
        </div>

<!-- Example input switch -->
      <div class="modal-body text-left padding-left-24 padding-right-24 padding-top-0 padding-bottom-0">
        <div class="row">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col- margin-bottom-0">
            <div class="pull-left w-100 padding-left-0 padding-right-0 margin-top-0">
              <div class="pull-left w-100 padding-bottom-0 margin-top-14 relative-content">

                <div class="input-wrapper">  <!-- toggle class -->



                <form [formGroup]="userMobileLogin" #mobileForgotForm="ngForm"  *ngIf="loginTypes === 'mobile'"
                  (ngSubmit)="onClickSendOtpToMobile(userMobileLogin.get('sign_in_userid').value)">
                  <div class="mobile-login-row">
                    <mat-form-field class="calling-code" floatLabel="always">
                      <mat-label class="mat-label-font">
                        Country Code *
                      </mat-label>
                      <mat-select 
                        required 
                        [(value)]="callingCode">
                        <mat-option [value]="callingCode">{{ callingCode }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field class="mobile-number" floatLabel="always">
                      <mat-label
                        [ngClass]="userMobileLogin.get('sign_in_userid').touched && userMobileLogin.get('sign_in_userid').errors ? 'oriya-color8' : 'oriya-color1'"
                        class="mat-label-font font-size2 font-mbold" required
                        >Mobile Number *</mat-label>
                      <input formControlName="sign_in_userid"  inputmode="numeric" autocomplete="off"
                      maxlength="10" minlength="10" type="text" matInput
                      (cut)="$event.preventDefault()" (copy)="$event.preventDefault()" (paste)="$event.preventDefault()"
                      placeholder="eg: 000 000 0000" id="place-hold-clr" (keypress)="numberOnly($event)">
                    </mat-form-field>
                  </div>
                  <div class="login-group-button">
                    <button type="button" [disabled]="showLoginOTP" 
                    (click)="closePop('logoutform')"
                    class="low-prior-cancel"
                    matSuffix>Cancel</button>
                    <button type="submit" [disabled]="showLoginOTP" 
                    [ngClass]="showLoginOTP ? 'oriya-btn-grn_new' :'login_sub_btn continue'"
                    matSuffix>Continue</button>
                  </div>
                  <div class=" w-100 text-center margin-top-20 margin-bottom-27 padding-bottom-12 padding-top-12 padding-right-48 padding-left-48">
                    <p class="oriya-color2 font-size2 font-mbold font-normal m-0" target="blank"> 
                      Not a member?
                      <span class="register-link" (click)="showPop('register-popup','')">REGISTER</span>
                    </p>
                    <!-- <button [disabled]="!showLoginOTP
                    "type="submit" class="text-uppercase font-mbold " 
                    [ngClass]="showLoginOTP ? 'oriya-btn-grn_new' :'login_sub_btn'"
                    (click)="showPop('signin_otp_pop','')">NEXT</button> -->
                  </div>
                </form>

                 <form [formGroup]="userEmailPasswordLogin" #mobileForgotForm="ngForm"  *ngIf="loginTypes === 'email'"
                  (ngSubmit)="onClickEmail()">

                     <div class="margin-bottom-32 margin-right-30">
                      <p class="profile_title">Email ID *</p>
                      <input formControlName="email" id="email" type="text" class="profile_input_line" placeholder="Enter your email id">
                    </div>

                     <div class="margin-bottom-32 margin-right-30">
                      <p class="profile_title">Password *</p>
                      <input formControlName="password" id="password" type="password" class="profile_input_line" placeholder="Enter your password">
                    </div>
                   
                    
                  <div class="login-group-button pb-4">
                    <button type="button" [disabled]="showLoginOTP" 
                    (click)="closePop('emailpop')"
                    class="low-prior-cancel"
                    matSuffix>Cancel</button>
                    <button type="submit" [disabled]="showLoginOTP" 
                    [ngClass]="showLoginOTP ? 'oriya-btn-grn_new' :'login_sub_btn continue'"
                    matSuffix>Login</button>
                  </div>

                 

                <div class=" w-100 text-center margin-top-20 margin-bottom-27 padding-bottom-12 padding-top-12  padding-left-12">
                     <p class="forgot-password"
                  (click)="forgotpopup()">
                  Forgot password?
                </p>
                  </div>
                  
                </form>
 
 

             
              </div>
              
                
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
<!--dangal sign in pop up ends/mobile number -->




<div class="modal model-overflow cdk-overlay-dark-backdrop" id="forgot_password_pop">
  <div class="modal-dialog">
    <div class="modal-content user_flow otp-sign-in">

      <div class="modal-header border-0 padding-left-24 padding-right-24 padding-top-13 padding-bottom-15 flex flex-items-center flex-space-between">
        <div class="w-100">
          <p class="font-normal font-mbold font-size4 oriya-color6 margin-bottom-10 centered-text">Forgot Password</p>
        </div>
        <!-- <img lazyLoad="./assets/images/icon_close.svg" alt="" title="" id="signin_close"
          (click)="closePop('loginform');"> -->
      </div>
     

        <!-- <div class="toggle-container">
          <button
            class="toggle-btn"
            [class.active]="loginTypes === 'email'"
            (click)="setLoginType('email')">
            Email
          </button>
          <button
            class="toggle-btn"
            [class.active]="loginTypes === 'mobile'"
            (click)="setLoginType('mobile')">
            Mobile
          </button>
        </div> -->

<!-- Example input switch -->

      <div class="modal-body text-left padding-left-24 padding-right-24 padding-top-0 padding-bottom-0">
        <div class="row">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col- margin-bottom-0">
            <div class="pull-left w-100 padding-left-0 padding-right-0 margin-top-0">
              <div class="pull-left w-100 padding-bottom-0 margin-top-14 relative-content">

                <div class="input-wrapper">  <!-- toggle class -->



               <!-- <form [formGroup]="userMobileLogin" #mobileForgotForm="ngForm"  *ngIf="loginTypes === 'mobile'">
                 <p class="profile_title">To reset your password, enter your registered Mobile Number</p>
                  <div class="padding-top-15 flex flex-space-between">
                    <mat-form-field class="w-20 calling-code" floatLabel="always">
                      <mat-label class="mat-label-font">
                        Country Code *
                      </mat-label>
                      <mat-select 
                        required 
                        [(value)]="callingCode">
                        <mat-option [value]="callingCode">{{ callingCode }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field [floatLabel]="floatLabelControl.value" class="w-7.5 mobile-number">
                      <mat-label
                        [ngClass]="userMobileLogin.get('sign_in_userid').touched && userMobileLogin.get('sign_in_userid').errors ? 'oriya-color8' : 'oriya-color1'"
                        [style.fontSize.px]="18" [style.lineHeight.px]="19" class="font-size2 font-mbold" required placeholder=""
                        >Mobile Number *</mat-label>
                        <div style="display: flex;color: white;">
                          <input formControlName="sign_in_userid"  inputmode="numeric" autocomplete="off"
                          maxlength="10" minlength="10" type="text" matInput
                          (cut)="$event.preventDefault()" (copy)="$event.preventDefault()" (paste)="$event.preventDefault()"
                          class="profile_pop_input_wid" placeholder="eg: 000 000 0000" id="place-hold-clr" (keypress)="numberOnly($event)">
                        </div>
                    </mat-form-field>
                  </div>
                  <div class="login-group-button">
                    <button [disabled]="showLoginOTP" 
                    (click)="closePop('emailpop')"
                    class="low-prior-cancel"
                    matSuffix>Cancel</button>
                    <button [disabled]="showLoginOTP" 
                    (click)="onClickMobileForgot(userMobileLogin.get('sign_in_userid').value)"
                    [ngClass]="showLoginOTP ? 'oriya-btn-grn_new' :'login_sub_btn continue'"
                    matSuffix>Confirm</button>
                  </div>
                 
                </form> -->

                 <form [formGroup]="userForgotPassword" #mobileForgotForm="ngForm" >
                     <p class="profile_title pb-2">To reset your password, enter your registered email address</p>

                     <div class="margin-bottom-32 margin-right-30">
                     
                      <input formControlName="email" id="email" type="text" class="profile_input_line" placeholder="Enter your email id">
                    </div>

                    
                  <div class="login-group-button pb-4">
                    <button [disabled]="showLoginOTP" 
                    (click)="closePop('emailpop')"
                    class="low-prior-cancel"
                    matSuffix>Cancel</button>
                    <button [disabled]="showLoginOTP" 
                    (click)="forgotEmail()"
                    [ngClass]="showLoginOTP ? 'oriya-btn-grn_new' :'login_sub_btn continue'"
                    matSuffix>Confirm</button>
                  </div>
                  
                </form>
 
 

             
              </div>

                
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>



<!-- dangal-sign-in-otp pop-up starts/mobile number -->
<div class="modal otp-verfication-bg cdk-overlay-dark-backdrop" id="signin_otp_pop" data-keyboard="false"  >
  <div class="modal-dialog">
    <div class="modal-content user_flow">
      <div class="modal-header border-0 padding-left-24 padding-right-24 padding-top-14 
        padding-bottom-14 flex flex-items-center flex-space-between">
        <div class="w-100">
          <p class="otp-verify-text font-mbold font-normal font-size4 oriya-color6 margin-bottom-10">OTP Verification</p>
          <p class="oriya-color2 font-size2 font-mbold font-normal m-0" target="blank"> Enter the OTP sent to your mobile number via SMS</p>
        </div>
        <!-- <img lazyLoad="./assets/images/icon_close.svg" alt="" title="" id="fgt_pwd_close"
          (click)="closePop('forgotpasswordotpform');"> -->
      </div>

      <div class="modal-body text-left padding-left-10 padding-right-10 margin-top-16 padding-bottom-0 padding-top-0">
        <div class="row">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col- margin-bottom-0">
            <div class="pull-left w-100 padding-left-0 padding-right-0 margin-top-0">
              <div class="pull-left w-100 padding-bottom-0  relative-content">

                <div class="text-center">
                  <p class="oriya-color6 font-mbold otp-sent-mobile">
                    {{ forgotPassMobileNumber || ((callingCode || '+91') + ' ' + (userMobileLogin?.get('sign_in_userid')?.value || '')) }}
                  </p>
                </div>

                <div class="flex flex-column otp-verify margin-top-30 margin-left-60">
                  <p class="oriya-color1 font-size5 margin-left-60" id="otp-p"> Enter 4 digit code</p>
                  <div class="w-100 otp-parent margin-top-10 padding-left-30 margin-left-13">
                    <form #verifyTokenForm="ngForm" [formGroup]="verifyToken" class="pull-left center-align-content margin-right-30">
                      <input formControlName="in1" class="tvVeri"  matInput type="text" class="mr-2" inputmode="numeric" maxlength="1"
                        (keyup)="keytab($event)" id="reg-otp-input" placeholder="0"  (keypress)="numberOnly($event)" autocomplete="off"/>
                      <input formControlName="in2" class="tvVeri" matInput type="text" inputmode="numeric" class="mr-2" maxlength="1"
                        (keyup)="keytab($event)" id="reg-otp-input" placeholder="0" (keypress)="numberOnly($event)" autocomplete="off"/>
                      <input formControlName="in3" class="tvVeri" matInput type="text" inputmode="numeric" class="mr-2" maxlength="1"
                        (keyup)="keytab($event)" id="reg-otp-input" placeholder="0"  (keypress)="numberOnly($event)" autocomplete="off"/>
                      <input formControlName="in4" class="tvVeri" matInput type="text" inputmode="numeric" class="mr-2" maxlength="1"
                        (keyup)="keytab($event)" id="reg-otp-input" placeholder="0" (keypress)="numberOnly($event)" autocomplete="off"/>
                    </form>
                    <div class="padding-left-30 counter-otp-parent"> 
                      <!-- <button [disabled]="true" class="counter-otp text-center font-size2 font-mbold margin-top-5 ">50 Sec</button> -->
                      <button  [disabled]="true" class="counter-otp text-center font-size2 font-mbold margin-top-5 " *ngIf='timer.sec !== 0' >{{timer.sec}} 
                       <span class="font-size0">sec</span>
                      </button>
                      <button  (click)="resendOtp(mobileNumber || registerForm.get('email_id').value || userMobileLogin.get('sign_in_userid').value)"  class="counter-otp-resend text-center font-size2  font-mbold margin-top-5 " *ngIf='timer.sec == 0' >RESEND</button>
                    </div>
                  </div>
                </div>
                <div class="text-center margin-bottom-10 m-0 font-size2 form_bottom padding-top-15" *ngIf='timer.sec == 0'>
                  <span class="font-mbold oriya-color2"  [style.lineHeight.px]="23" >Didn't receive the OTP click on  <br> "RESEND"</span>
                </div>
                <div class="flex margin-bottom-40 margin-top-40" style="flex-direction: row;align-items: center;gap: 35px;justify-content: center;">
                  <div class="">
                    <button class="low-prior-cancel" (click)="showPop('signin_pop','')"  [style.fontSize.px]="14"  [style.lineHeight.px]="19" >Back
                    </button>
                  </div>
                  <div>
                    <button [ngClass]="verifyToken.valid ? 'oriya-btn-grn_new': 'login_sub_btn' " type="submit" class="text-uppercase font-mbold  "
                    (click)="onClickLogin('')">Verify</button>
                  </div>
                </div>
                <p class="oriya-color2 font-size2 font-mbold footer-text m-0" target="blank"> OTP will be sent to the above mentioned Mobile number.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- dangal-sign-in-otp pop-up ends/mobile number -->

<!-- dangal-sign-in pop-up starts /email-->
<div class="modal model-overflow cdk-overlay-dark-backdrop" id="signin_email_pop">
  <div class="modal-dialog">
    <div class="modal-content user_flow ">

      <div class="modal-header border-0 padding-left-24 padding-right-24 padding-top-13 padding-bottom-15 flex flex-items-center flex-space-between">
        <div class="w-100">
          <p class="font-normal font-mbold font-size4 oriya-color6 margin-bottom-10 regional-user">Login </p>
          <p class="oriya-color2 font-size2 font-mbold font-normal m-0" target="blank"> Login or Registered Using Google </p>
        </div>
        <img lazyLoad="./assets/images/icon_close.svg" alt="" title="" id="signin_close"
          (click)="closePop('loginemailform');">
      </div>

      <div class="modal-body text-left padding-left-24 padding-right-24 padding-top-0 padding-bottom-0">
        <div class="row">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col- margin-bottom-0">
            <div class="pull-left w-100 padding-left-0 padding-right-0 margin-top-0">
              <div class="pull-left w-100 padding-bottom-0 margin-top-14 relative-content">

                <form [formGroup]="userEmailLogin" #emailLoginForm="ngForm" >
                  <div class="login-group-button">
                    <button class="social-media-btn width-15 facebook-btn" (click)="signInWithGoogle()">
                      <img lazyLoad = "./assets/tarangplus/icon_google.svg" class="google-icon">
                      <span class="signin_with_google">Continue with Google</span></button>
                  </div>
                  <div class="login-group-button">
                    <button class="social-media-btn width-15 facebook-btn" (click)="signInWithFacebook()">
                      <img lazyLoad = "./assets/tarangplus/facebook.svg" class="fb-icon">
                      <span class="signin_with_google">Login with Facebook</span></button>
                  </div>

      <div class="modal-body text-left padding-left-24 padding-right-24 padding-top-0 padding-bottom-0">
        <div class="row">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col- margin-bottom-0">
            <div class="pull-left w-100 padding-left-0 padding-right-0 margin-top-0">
              <div class="pull-left w-100 padding-bottom-0 margin-top-14 relative-content">
                <div class="input-wrapper">
                  <form [formGroup]="userEmailPasswordLogin" #mobileForgotForm="ngForm"  *ngIf="loginTypes === 'email'"
                    (ngSubmit)="onClickEmail()">

                     <div class="margin-bottom-32 margin-right-30">
                      <p class="profile_title">Email ID *</p>
                      <input formControlName="email" id="email" type="text" class="profile_input_line" placeholder="Enter your email id">
                    </div>

                     <div class="margin-bottom-32 margin-right-30">
                      <p class="profile_title">Password *</p>
                      <input formControlName="password" id="password" type="password" class="profile_input_line" placeholder="Enter your password">
                    </div>
                   
                    
                  <div class="login-group-button pb-4">
                    <button type="button" [disabled]="showLoginOTP" 
                    (click)="closePop('emailpop')"
                    class="low-prior-cancel"
                    matSuffix>Cancel</button>
                    <button type="submit" [disabled]="showLoginOTP" 
                    [ngClass]="showLoginOTP ? 'oriya-btn-grn_new' :'login_sub_btn continue'"
                    matSuffix>Login</button>
                  </div>
                  
                </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
                
                  <div class=" w-100 text-center margin-top-20 margin-bottom-27 padding-bottom-12 padding-top-12
                  padding-right-48 padding-left-48">
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
<!--dangal sign in pop up ends/email -->

<!-- dangal-sign-in-otp pop-up starts/email -->
<div class="modal otp-verfication-bg cdk-overlay-dark-backdrop" id="signin_otp_pop_email" data-keyboard="false"  >
  <div class="modal-dialog">
    <div class="modal-content user_flow ">
      <div class="modal-header border-0 padding-left-24 padding-right-24 padding-top-14 
        padding-bottom-14 flex flex-items-center flex-space-between">
        <div class="w-100">
          <p class="font-mbold font-normal font-size4 oriya-color6 margin-bottom-10">OTP Verification</p>
          <p class="oriya-color2 font-size2 font-mbold font-normal m-0" target="blank"> Enter the OTP sent to your email id</p>
        </div>
        <img lazyLoad="./assets/images/icon_close.svg" alt="" title="" id="fgt_pwd_close"
          (click)="closePop('forgotpasswordotpformemail');">
      </div>

      <div class="modal-body text-left padding-left-10 padding-right-10 margin-top-16 padding-bottom-0 padding-top-0">
        <div class="row">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col- margin-bottom-0">
            <div class="pull-left w-100 padding-left-0 padding-right-0 margin-top-0">
              <div class="pull-left w-100 padding-bottom-0  relative-content">

                <div>
                  <mat-form-field [floatLabel]="floatLabelControl.value" class="col-sm-12 col-md-12 col-lg-12">
                   <mat-label [style.fontSize.px]="18"  [style.lineHeight.px]="19" class="oriya-color6 font-size2 font-mbold">Email Id *</mat-label>
                    <input [formControl]="forgot_pasword_email" id="place-hold-clr" class="oriya-color6 font-size1 "
                      matInput  placeholder="eg: johndoe@mail.com" readonly="true" 
                      >
                  </mat-form-field>
                  <p class="oriya-color2 font-size2 text-center padding-top-5 ">{{forgotPassEmailId}}
                  </p>
                </div>

                <div class="flex flex-column">
                  <p class="oriya-color1 font-size5 margin-left-60" id="otp-p"> Enter 4 digit code</p>
                  <div class="w-100 otp-parent margin-top-10 padding-left-30 margin-left-30 ">
                    <form #verifyTokenEmailForm="ngForm" [formGroup]="verifyTokenEmail" class="pull-left center-align-content margin-right-30">
                      <input formControlName="in1" class="tvVeri"  matInput type="text" class="mr-2" inputmode="numeric" maxlength="1"
                        (keyup)="keytab($event)" id="reg-otp-input" placeholder="0"  (keypress)="numberOnly($event)" autocomplete="off"/>
                      <input formControlName="in2" class="tvVeri" matInput type="text" inputmode="numeric" class="mr-2" maxlength="1"
                        (keyup)="keytab($event)" id="reg-otp-input" placeholder="0" (keypress)="numberOnly($event)" autocomplete="off"/>
                      <input formControlName="in3" class="tvVeri" matInput type="text" inputmode="numeric" class="mr-2" maxlength="1"
                        (keyup)="keytab($event)" id="reg-otp-input" placeholder="0"  (keypress)="numberOnly($event)" autocomplete="off"/>
                      <input formControlName="in4" class="tvVeri" matInput type="text" inputmode="numeric" class="mr-2" maxlength="1"
                        (keyup)="keytab($event)" id="reg-otp-input" placeholder="0" (keypress)="numberOnly($event)" autocomplete="off"/>
                    </form>
                    <div class="padding-left-30 counter-otp-parent"> 
                      <!-- <button [disabled]="true" class="counter-otp text-center font-size2 font-mbold margin-top-5 ">50 Sec</button> -->
                      <button  [disabled]="true" class="counter-otp text-center font-size2 font-mbold margin-top-5 " *ngIf='timer.sec !== 0' >{{timer.sec}} 
                       <span class="font-size0">sec</span>
                      </button>
                      <button  (click)="resendOtpEmail(userEmailLogin.get('sign_in_userid').value)"  class="counter-otp-resend text-center font-size2  font-mbold margin-top-5 " *ngIf='timer.sec == 0' >RESEND</button>
                    </div>
                  </div>
                </div>
                <div class="text-center margin-bottom-40 m-0 font-size2 form_bottom padding-top-40" *ngIf='timer.sec == 0'>
                  <span class="font-mbold oriya-color2"  [style.lineHeight.px]="23" >Didn't receive the OTP click on  <br> "RESEND"</span>
                </div>
                <div class="flex margin-bottom-40 margin-top-40" style="flex-direction: row;align-items: center;gap: 35px;justify-content: center;">
                  <div class="">
                    <button class="low-prior-cancel" (click)="showPop('signin_email_pop','')"  [style.fontSize.px]="14"  [style.lineHeight.px]="19" >BACK
                    </button>
                  </div>
                  <div>
                    <button [ngClass]="verifyTokenEmail.valid ? 'oriya-btn-grn_new': 'login_sub_btn' " type="submit" class="text-uppercase font-mbold  "
                    (click)="onClickEmailLogin('')">NEXT</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- dangal-sign-in-otp pop-up ends/email -->


<!-- dangal-my-profile-pop-up starts-->
<div class="modal cdk-overlay-dark-backdrop" id="my-profile_pop" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog">
    <div class="modal-content user_flow">

      <div
        class="modal-header border-0  w-100 padding-left-24 padding-right-24 padding-top-25 padding-bottom-16  flex flex-space-between">
        <p class="font-semibold font-size4 oriya-color6 padding-top-5 margin-bottom-10 margin-left-editProfile">{{showUpdateProfile === false ? 'My Profile' : 'Edit Profile'}}</p>
        <div class="flex">
      
          <!-- <img lazyLoad="./assets/images/icon_close.svg" alt="" title="" id="profile_close" class="margin-top-5"
            (click)="closePop('profileform');"> -->
        </div>
      </div>

      <div class="modal-body text-left padding-left-24 padding-right-24 padding-top-0">
        <div class="row">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12  margin-bottom-0">
            <div class="pull-left w-100 padding-left-0 padding-right-0 margin-top-0">
              <div class="pull-left w-100 padding-bottom-0 padding-top-30 relative-content">

                <!-- displayDetails -->
                <div *ngIf="!showUpdateProfile" class="user_details user-detail-block">
                  <div class="personal-data">
                  <div class="margin-bottom-32 margin-right-30">
                    <p class="profile_title">Name *</p>
                    <!-- <p class="profile_data">{{user.firstname ? user.firstname : '-'}}</p> -->
                    <input type="text" class="profile_input_line" [value]="user.firstname ? user.firstname : '-'" readonly>
                  </div>

                  <div class="margin-bottom-32">
                    <p class="profile_title">Mobile Number *</p>
                    <!-- <p class="profile_data">{{user.mobile_number ? user.mobile_number : '-'}}</p> -->
                    <input type="text" class="profile_input_line" [value]="user.mobile_number ? user.mobile_number : '-'" readonly>
                  </div>
                </div>
              
                <div class="personal-data">
                  <div class="margin-bottom-32 margin-right-30">
                    <p class="profile_title">Email Id</p>
                    <input type="text" class="profile_input_line" [value]="user.email_id ? user.email_id :user.ext_email_id?user.ext_email_id: '_'" readonly>
                  </div>

                  <div class="margin-bottom-32">
                    <p class="profile_title">Age</p>
                    <input type="text" class="profile_input_line" [value]="user.age ? user.age : '-'" readonly>
                  </div>
                </div>

                  <div class="edit w-100 text-center margin-top-20 margin-bottom-20  padding-top-12 padding-right-48 padding-left-48 login-group-button">
                    <button [disabled]="showLoginOTP" 
                    (click)="closePop('logoutform')"
                    class="low-prior-cancel"
                    matSuffix>Cancel</button>
                    <button type="submit" class="text-uppercase font-mbold login_sub_btn continue "
                    (click)="onClickEditProfile()"
                    >Edit</button>
                  </div>
                  <div class=" w-100 text-center margin-top-20 margin-bottom-27 padding-bottom-12 padding-top-12 padding-right-48 padding-left-48">
                    <p class="oriya-color2 font-size2 font-mbold font-normal m-0">
                      Click to "delete" Tarang account! 
                      <a href="javascript:void(0)" (click)="showPop('delete-popup','')" class="delete-link">DELETE</a>
                    </p>                   
                    </div>
                </div>
                



                <!-- displayDetails ends -->

                <!-- edit details -->
                <ng-container *ngIf="showUpdateProfile">
                  <form [formGroup]="userProfile" #userProfileForm="ngForm">
                    <div class="personal-data">
                      <div class="padding-top-10 flex flex-space-between">
                        <mat-form-field [floatLabel]="floatLabelControl.value" class="w-100 margin-right-30">
                          <mat-label
                            [ngClass]="userProfile.get('user_profile_name').touched && userProfile.get('user_profile_name').errors ? 'oriya-color8' : 'oriya-color1'"
                            [style.fontSize.px]="16" class="font-size2 font-mbold" required>
                            Name</mat-label>
                          <input formControlName="user_profile_name" type="text" maxlength="50" placeholder="John Doe" matInput
                            class="profile_pop_input_wid" id="place-hold-clr" autocomplete="off">
                          <mat-error *ngIf="userProfile.get('user_profile_name').hasError('pattern')">Enter alphabets only</mat-error>
                        </mat-form-field>
                      </div>
                  
                  <div class="padding-top-10 flex flex-space-between ">
                    <mat-form-field [floatLabel]="floatLabelControl.value" class="phn w-100 margin-right-30">
                      <mat-label
                        [ngClass]="userProfile.get('user_profile_mobileNo').touched && userProfile.get('user_profile_mobileNo').errors ? 'oriya-color8' : 'oriya-color1'"
                        [style.fontSize.px]="16" class="font-size2 font-mbold">
                        Mobile Number
                      </mat-label>
                      <!-- <input formControlName="user_profile_mobileNo" type="text" autocomplete="off" class="profile_pop_input_wid" matInput
                                                                   placeholder="131123456789" id="place-hold-clr" digitLimit [maxDigits]="15"> -->
                      <input formControlName="user_profile_mobileNo" autocomplete="off" class="profile_pop_input_wid" matInput
                        placeholder="131123456789" id="place-hold-clr" (keypress)="numberOnlyForInternationalUsers($event)"
                        maxlength="15">
                      <mat-error *ngIf="userProfile.get('user_profile_mobileNo').hasError('pattern')">Enter a valid Mobile
                        Number</mat-error>
                      <mat-error *ngIf="userProfile.get('user_profile_mobileNo').hasError('maxlength')">Mobile number cannot exceed 15
                        digits</mat-error>
                    </mat-form-field>
                  
                  
                  
                  </div>
                  
                      
                    </div>
                    <div class="personal-data">
                      <!-- <div *ngIf="region != 'IN'" class="padding-top-10 flex flex-space-between "> -->
                      <div class="padding-top-10 flex flex-space-between ">
                        <mat-form-field [floatLabel]="floatLabelControl.value" class="phn w-100 margin-right-30">
                          <mat-label
                            [ngClass]="userProfile.get('user_profile_email').touched && userProfile.get('user_profile_email').errors ? 'oriya-color8' : 'oriya-color1'"
                            [style.fontSize.px]="16" class="font-size2 font-mbold">
                            Email Id</mat-label>
                          <input formControlName="user_profile_email" type="email" autocomplete="off" class="profile_pop_input_wid" matInput 
                            placeholder="johndoe@mail.com" id="place-hold-clr">
                          <mat-error *ngIf="userProfile.get('user_profile_email').hasError('pattern')">Enter valid email id</mat-error>
                        </mat-form-field>
                      </div>
                  
                      <div class="padding-top-10 flex flex-space-between">
                        <mat-form-field [floatLabel]="floatLabelControl.value" class="w-100 margin-right-30">
                          <mat-label
                            [ngClass]="userProfile.get('user_profile_age').touched && userProfile.get('user_profile_age').errors ? 'oriya-color8' : 'oriya-color1'"
                            [style.fontSize.px]="16" class="font-size2 font-mbold" required>
                            Age</mat-label>
                          <mat-select formControlName="user_profile_age" class="profile_age_input_wid" id="place-hold-clr" required>
                            <mat-option *ngFor="let age of ageOptions" [value]="age">{{ age }}</mat-option>
                          </mat-select>
                          <!-- <input formControlName="user_profile_age" autocomplete="off"  (keypress)="numberOnly($event)" inputmode="numeric" minlength="2"  maxlength="3" pattern="[0-9]*" placeholder="30" matInput class="profile_pop_input_wid" id="place-hold-clr">                   -->
                        </mat-form-field>
                      </div>
                    </div>
                    <div
                      class=" w-100 text-center margin-top-20 margin-bottom-20  padding-top-12 padding-right-48 padding-left-48 edit-group-button">
                      <button [disabled]="showLoginOTP" (click)="showUpdateProfile = false" class="low-prior-cancel"
                        matSuffix>Cancel</button>
                      <button type="submit" class="text-uppercase font-mbold edit-group-save ml-4" [disabled]="userProfileForm.invalid"
                        [ngClass]="userProfile.touched && userProfile.valid ? 'oriya-btn-grn_new': 'login_sub_btn continue'"
                        (click)="onclickUpdateUserProfile()">Save</button>
                    </div>
                  </form>
                </ng-container>
              

                <!-- edit details end -->
              </div>
            </div>
          </div>
        </div>
      </div>
      
      
    </div>
  </div>
</div>




<div class="modal model-overflow cdk-overlay-dark-backdrop" id="reset_password_pop">
  <div class="modal-dialog">
    <div class="modal-content user_flow">

      <!-- HEADER -->
      <div class="modal-header border-0 padding-left-24 padding-right-24 padding-top-13 padding-bottom-15 flex flex-items-center flex-space-between">
        <div class="w-100">
          <p class="font-normal font-mbold font-size4 oriya-color6 margin-bottom-10">
            Reset Password
          </p>
        </div>
        <img
          src="./assets/images/icon_close.svg"
          id="signin_close"
          (click)="closePop('reset_password_pop')"
        />
      </div>

      <!-- BODY -->
      <div class="modal-body padding-left-24 padding-right-24 padding-bottom-24">

       <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()">

  <!-- New Password -->
  <div class="margin-bottom-32">
    <p class="profile_title">New Password *</p>

    <div style="position: relative;">
      <input
        formControlName="password"
        [type]="showPassword ? 'text' : 'password'"
        autocomplete="off"
        class="profile_pop_input_wid"
        matInput
        placeholder="Enter new password"
      />

      <img
        [src]="showPassword 
          ? 'assets/images/hide_password.svg' 
          : 'assets/images/show_password.svg'"
        (click)="togglePassword()"
        style="
          position: absolute;
          right: 12px;
          top: 50%;
          transform: translateY(-50%);
          cursor: pointer;
          width: 18px;
          height: 18px;
        "
      />
    </div>

    <mat-error *ngIf="submitted && changePasswordForm.get('password')?.hasError('required')">
      Password is required
    </mat-error>

    <mat-error *ngIf="submitted && changePasswordForm.get('password')?.hasError('minlength')">
      Password must be at least 6 characters
    </mat-error>
  </div>

  <!-- Confirm Password -->
  <div class="margin-bottom-32">
    <p class="profile_title">Confirm Password *</p>

    <div style="position: relative;">
      <input
        formControlName="confirm_password"
        [type]="showConfirmPassword ? 'text' : 'password'"
        autocomplete="off"
        class="profile_pop_input_wid"
        matInput
        placeholder="Re-enter password"
      />

      <img
        [src]="showConfirmPassword 
          ? 'assets/images/hide_password.svg' 
          : 'assets/images/show_password.svg'"
        (click)="toggleConfirmPassword()"
        style="
          position: absolute;
          right: 12px;
          top: 50%;
          transform: translateY(-50%);
          cursor: pointer;
          width: 18px;
          height: 18px;
        "
      />
    </div>

    <mat-error *ngIf="submitted && changePasswordForm.get('confirm_password')?.hasError('required')">
      Confirm password is required
    </mat-error>

    <mat-error *ngIf="submitted && changePasswordForm.get('confirm_password')?.hasError('mismatch')">
      Password and Confirm Password must match
    </mat-error>
  </div>

  <!-- Submit Button -->
  <div class="login-group-button pb-4">
    <button type="submit"
            class="login_sub_btn continue">
      Reset Password
    </button>
  </div>

</form>

      </div>
    </div>
  </div>
</div>
<!-- dangal-my-profile-pop-up ends -->

<!-- No Internet pop-up -->
<div class="modal cdk-overlay-dark-backdrop" id="no_internet_pop" >
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body text-left padding-left-28 padding-right-28 padding-top-0">
        <div class="row">
          <div class="empty-watchlist" >
            <img lazyLoad="./assets/tarangplus/icon_noInternetConnection.svg" class="emptyWatchlist_image" >
            <p class="margin-bottom-25 text-center font-size3 oriya-color1">Oops..!</p>
            <p class="margin-bottom-40 text-center oriya-color2 font-size2" style="line-height: 21px;" >Slow or no internet connection. <br>  Please check your internet setting.</p>
            <div class="text-center ">
              <a (click)="reload()" class=" browse-btn font-medium">Try Again</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--Session expired starts-->
<div class="modal small-popup" id="session_expired" *ngIf="isSessionExpired">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body text-left padding-left-28 padding-right-28 padding-top-30 padding-bottom-30">
        <p class="margin-bottom-15 text-center font-size1 oriya-color1">Session expired</p>
        <p class="margin-bottom-15 text-center font-size2 oriya-color2">Your current session has expired.<br>Please login again.</p>
        <div class="text-center margin-bottom-15">
          <a (click)="refreshPage()" class="browse-btn font-medium margin-bottom-0 text-capitalize inline-block">Ok</a>
        </div>
        <p class="text-center oriya-color4 font-size6">Note: Please note that you can only<br>login to 2 devices simultaneously.</p>
      </div>
    </div>
  </div>
</div>
<!--Session expired ends-->


<!--GDPI popup starts-->
<div class="modal cdk-overlay-dark-backdrop small-popup" id="gdpi_popup" *ngIf="shouldShowPopup()">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body text-left padding-left-28 padding-right-28 padding-top-30 padding-bottom-30">
            <p class="margin-bottom-15 text-center font-size1 oriya-color1">Terms Of Service and Usage</p>
            <p class="oriya-color2 gdpr-text font-size2 font-mbold font-normal m-0">
              Please take a minute to review the terms and conditions for using our services. 
              Our terms describe how we use your data in accordance with the applicable laws 
              and the options available to you.
            </p>
            <form [formGroup]="formGroupGDPI" class="relative-content">
              <p class="oriya-color2 margin-top-20">
                <input type="checkbox" formControlName="cb" class="custom-gdpr-checkbox"> I agree to <a target="_blank" href="https://www.ratri.app/terms_and_conditions">terms and conditions</a></p>
              <div class="all_error text-center" style="color: red; padding-top: 0.2rem" *ngIf="formGroupGDPI.hasError('required', 'cb')">
                Required
               </div>
               <div class="margin-top-20">
                <button class="w-100 browse-btn font-medium margin-bottom-0 text-capitalize inline-block" (click)="agreeGDPI()" type="submit" [disabled]="formGroupGDPI.invalid" [ngClass]="formGroupGDPI.invalid ? 'disabled-continuePayBtn': 'continuePayBtn'">CONTINUE</button>
              </div>
            </form>
      </div>
    </div>
  </div>
</div>
<!--GDPI popup ends-->

<!-- search starts -->
<div class="modal p-0" id="search_pop">
  <div class="modal-dialog">
    <div class="modal-content user_flow">
      <div class="modal-body text-left p-0">
        <app-search></app-search>
      </div>
    </div>
  </div>
</div>
<!-- /.search ends -->

<!-- log out pop  -->
<div class="modal cdk-overlay-dark-backdrop"  id="logout_pop">
  <div class="modal-dialog">
    <div class="modal-content user_flow">

      <div class="modal-header border-0 padding-left-24 padding-right-24 padding-top-30 padding-bottom-30 flex flex-items-center flex-space-between">
        <div class="w-100">
          <p class="font-mbold font-size4 oriya-color6 text-center">Alert!</p>
        </div>
        <!-- <img lazyLoad="./assets/images/icon_close.svg" alt="" title="" id="fgt_pwd_close"
          (click)="closePop('logoutform');"> -->
      </div>

      <div class="modal-body text-left padding-left-24 padding-right-24 padding-top-0">
        <div class="row">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col- margin-bottom-0">
            <div class="pull-left w-100 padding-left-0 padding-right-0 margin-top-0">
              <div class="pull-left w-100  relative-content">
                <p class="oriya-color2 font-size3 font-mbold m-0 text-center" target="blank">
                  Are you sure you want to logout?</p>


                   <div class="pull-left flex flex-items-center text-center w-100 padding-bottom-12 margin-top-40  center-align-content">
                    <button type="submit" class="login_sub_btn margin-bottom-40 text-center text-uppercase  font-mbold" value="sign in"
                    (click)="logoutConfirm('logoutform')">Yes</button>
                      <button type="submit" class=" logout-confirm low-prior-cancel margin-left-10 margin-bottom-40 text-center text-uppercase"
                      (click)="closePop('logoutform')">No</button>
                  </div>

                
              </div>
            </div>
          </div>
        </div>
      </div>




    </div>
  </div>
</div>
<!-- log out pop ends -->
<div class="modal cdk-overlay-dark-backdrop" id="register-popup">
  <div class="modal-dialog">
      <div class="modal-content user_flow">
          <div class="modal-header border-0 padding-left-24 padding-right-24 padding-top-30 padding-bottom-30 flex flex-items-center flex-space-between">
              <div class="w-100">
                  <p class="font-mbold font-size4 oriya-color6 text-center">Register</p>
                  <p class="oriya-color2 font-size2 font-mbold font-normal m-0" target="blank"> Will be registered using OTP </p>
              </div>
              <!-- <img lazyLoad="./assets/images/icon_close.svg" alt="" title="" id="fgt_pwd_close"
                  (click)="closePop('logoutform');"> -->
          </div>
          <form [formGroup]="registerForm" (ngSubmit)="onRegister()">
          <div  class="user_details user-detail-block">
            <div class="personal-data">
            <div class="margin-bottom-32 margin-right-30">
              <p class="profile_title"> Full Name *</p>
              <input formControlName="firstname" type="text" class="profile_input_line" placeholder="eg: John Doe">
            </div>
            <div class="margin-bottom-32">
              <p class="profile_title"> Email Id</p>
              <input formControlName="user_email_id"  type="email" class="profile_input_line" placeholder="eg: johndoe@mail.com">
              <p
                *ngIf="(hasAttemptedSubmit || registerForm.get('user_email_id').touched) && registerForm.get('user_email_id').hasError('pattern')"
                class="tc-error-message"
                style="color: #F14336; margin-top: 6px; font-size: 12px;"
              >Please enter a valid Email Address</p>
            </div>
          </div>
          <div class="personal-data">
            <div class="margin-bottom-32 margin-right-30">
              <p class="profile_title"> Country Code *</p>
              <input formControlName="region" value="+91" type="text" class="profile_input_line" readonly="true">
            </div>
            <div class="margin-bottom-32">
              <p class="profile_title">Mobile Number *</p>
              <input
                formControlName="email_id"
                type="text"
                class="profile_input_line"
                placeholder="eg: 000 000 0000"
                maxlength="10" 
                (input)="onInputChange($event)"
                pattern="[0-9]*"
              >
              <p
                *ngIf="(hasAttemptedSubmit || registerForm.get('email_id').touched) && registerForm.get('email_id').invalid"
                class="tc-error-message"
                style="color: #F14336; margin-top: 6px; font-size: 12px;"
              >Please enter a valid Mobile Number</p>
            </div>
          </div>
            <div class="tacbox ">
              <input id="checkbox" type="checkbox" #checkbox (change)="onTermsChange($event)"/>
              <label for="checkbox" class="custom-checkbox oriya-color2 register-link"> By creating an account you agree to our</label><br>
              <p class="font-mbold font-normal register-link line-break" target="blank">Terms of Use <span> & </span>Your age is 18+ </p>
              <p *ngIf="hasAttemptedSubmit && !termsAccepted" class="tc-error-message text-center" style="color: #F14336;">Please accept the terms and conditions to proceed</p>
            </div>
            <div class="edit w-100 text-center margin-top-20 margin-bottom-20  padding-top-12 padding-right-48 padding-left-48 login-group-button">
              <button type="button"
              (click)="closeregisterPopup('register-popup')"
              class="low-prior-cancel"
              matSuffix>Cancel</button>
              <button type="submit" class="text-uppercase font-mbold login_sub_btn continue "
            
              (click)="showUpdateProfile = true"
              >Continue</button>
            </div>
            <div class=" w-100 text-center margin-top-20 margin-bottom-27 padding-bottom-12 padding-top-12 padding-right-48 padding-left-48">
              <p class="oriya-color2 font-size2 font-mbold font-normal m-0" target="blank">Already a member? 
                <span class="register-link" (click)="showPop('signin_pop','')">Login</span>
              </p>
            </div>
          </div>
          </form>
      </div>
  </div>
</div>

<!-- delete confirm -->
<div class="modal cdk-overlay-dark-backdrop" id="delete-popup">
  <div class="modal-dialog">
      <div class="modal-content user_flow">
          <div class="modal-header border-0 padding-left-24 padding-right-24 padding-top-30 padding-bottom-30 flex flex-items-center flex-space-between">
              <div class="w-100">
                  <p class="font-mbold font-size4 oriya-color6 text-center">Delete Account</p>
                  <p class="oriya-color2 font-size2 font-mbold font-normal m-0" target="blank"> are you sure you want to delete this account? </p>
              </div>
              <!-- <img lazyLoad="./assets/images/icon_close.svg" alt="" title="" id="fgt_pwd_close"
                  (click)="closePop('logoutform');"> -->
          </div>
            <div class="edit w-100 text-center margin-top-20 margin-bottom-20  padding-top-12 padding-right-48 padding-left-48 login-group-button">
              <button [disabled]="showLoginOTP" 
              (click)="closePop('logoutform')"
              class="low-prior-cancel"
              matSuffix>Cancel</button>
              <button type="submit" class="text-uppercase font-mbold login_sub_btn continue "
              (click)="confirmDeleteUser()"
              >Continue</button>
          </div>
      </div>
  </div>
</div>
 <!-- delete confirm ends -->
<!-- clear watch later pop-up -->
<div class="modal cdk-overlay-dark-backdrop" id="delete_watch" data-keyboard="false" >
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body text-left padding-left-30 padding-right-30">
        <p class="pull-left margin-bottom-10 font-semibold w-100 text-center page-title oriya-color">Alert!</p>
        <p class="pull-left w-100 margin-top-15 margin-bottom-25 text-center oriya-color2 font-size1">
          Are you sure you want to clear <br> <span class="d-block margin-top-5">watch history?  </span>
        </p>
        <div class="pull-left w-100 margin-bottom-20 margin-top-0 center-align-content">
          
          <a class="text-uppercase pull-left oriya-btn-grn_new" id="clear_watch_confirm"
            (click)="deleteWatchHistory()">Yes</a>

            <button class="text-uppercase pull-left margin-left-10 low-prior-cancel" (click)="closePop('deleteWatchHistory')">No</button>
        </div>
        <p class="pull-left w-100 margin-top-15 margin-bottom-25 text-center oriya-color2 font-size6">
          Note: All content in your continue<br/> watching list will be removed and<br/> this can't be undone!
        </p>
      </div>
    </div>
  </div>
</div>


<!-- signInRequired pop-up starts -->
<div class="modal retry_connecting cdk-overlay-dark-backdrop" id="closeSwitch-Network-PopUp"
  *ngIf="closeSwitchNetworkPopup  && (browser !== 'ios' && browser !== 'android')">
  <div class="modal-dialog">
    <div class="modal-content user_flow signin-popup login_alert">
      
      <div class="modal-header border-0 padding-left-24 padding-right-24 padding-top-32 pb-0">
        <p class="pull-left mb-0 padding-left-20 font-semibold w-100 text-center oriya-color font-size4">Alert!</p>
        <img lazyLoad="./assets/images/icon_close.svg" alt="" title="" (click)="closePop('signInRequired');"
          style="z-index: 10;">
      </div>
      
      <div class="modal-body text-center padding-left-24 padding-right-24 padding-bottom-0 padding-top-0">
        <p
          class="pull-left w-100  font-size2 text-center oriya-color2
            padding-left-30 padding-right-30 margin-top-20">
            Sign in required for this action
        </p>
        <div class="pull-left flex flex-items-center text-center w-100 padding-bottom-12 margin-top-10  center-align-content vertical-stack">
          <button type="submit" class="oriya-btn-grn_new margin-bottom-40 text-center  font-mbold" value="sign in"
            (click)="loginBasedonRegion()">Let's Login</button>
            <button type="submit" class="low-prior-cancel verticle-button  margin-bottom-40 text-center"
            (click)="closePop('signInRequired')">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- signInRequired pop-up ends -->


<div class="toster-message-wrap" id="retry_toast" *ngIf="retryToast">
  <div class="center-align-content">
    <div class="toster-message">
      <img lazyLoad="./assets/images/tick.svg" alt="" title="">
      <p id="watch_later_message">
        Please try again
      </p>
    </div>
  </div>
</div>

<!-- Account not valid for region error pop-up -->
<div class="modal cdk-overlay-dark-backdrop" id="region_change_pop" *ngIf="showDiffRegionPop">
  <div class="modal-dialog">
    <div class="modal-content" style="background: transparent; border: 0;">
      <!-- modal-content -->
      <div class="modal-body text-left padding-left-28 padding-right-28 padding-top-0">
        <div class="row">
          <div class="empty-watchlist" >
            <img lazyLoad="./assets/errorMessages/icon_regionChange.svg" class="emptyWatchlist_image" >
            <p class="margin-bottom-25 text-center font-size3 oriya-color1">Your Tarang account is not<br> valid for use in this region.</p>
            <p class="margin-bottom-40 text-center oriya-color2 font-size2" style="line-height: 21px;" >Continue to experience Tarang in this<br> region by Signing Up using credentials <br> valid for this region</p>
            <div class="text-center">
              <a (click)="loginBasedonRegion()" class="browse-btn font-medium cursor-pointer">SIGN IN</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>




<!-- first page sursangram pop-up starts -->
<div class="modal model-overflow sursangram padding-right-0 padding-left-0" id="sursangram_pop" *ngIf="showSursangramPop && browser != 'android' && browser != 'ios'">
  <div class="">
    <div class="modal-content user_flow ">
      <div class="float-right border-0 padding-left-24 padding-right-24 padding-top-14 
            padding-bottom-14 close_btndiv margin-top-0">
            <a>
              <img src="./assets/sursangam/icon_close.svg" alt="" title=""  class="sursangram_close"
              (click)="showSursangramPop = false">
    
            </a>
      </div>

      <div class="modal-body padding-0">
        <section class="w-100" id="section_float">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col- margin-bottom-0">
            <div class="sursangram_card center-align-content">
              <div class="flex flex-column center-align-content2">
                <img src="./assets/sursangam/your text here.png" class="d-none d-xl-block text_img">
                <img *ngIf="isDesktop" src="./assets/sursangam/01_bgnew_1366x768.png" class="banner-img">
                <img *ngIf="isTab" src="./assets/sursangam/01_iPad_bg.jpg" class="banner-img">
                <img *ngIf="isSTab" src="./assets/sursangam/01_tab_bg.jpg" class="banner-img">
                <img *ngIf="isMobile" src="./assets/sursangam/01_m_bg.jpg" class="banner-img">
      
                <a class="margin-top-40 sursangam_button sursangam_box_background  font-wt600 sursangam_color relative-content" (click)="loginCheckSursangram()">इहवां क्लिक करीं</a>
                <!-- <a class="sursangam_color font-size3 margin-top-28 d-none d-xl-block"  id="signin_close"
                (click)="closePop('sursangram_pop');" >close</a> -->
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</div>
<!-- first page pop-up ends -->


<!-- Parental lock  -->
<div class="modal cdk-overlay-dark-backdrop" id="parentak-popup" style="display: none;">
  <div class="modal-dialog">
    <div class="modal-content user_flow">
      <div class="modal-header border-0 padding-left-24 padding-right-24 flex flex-items-center flex-space-between">
        <div class="w-100">
          <p class="font-mbold font-size4 oriya-color6 text-center">Alert!</p>
          <p class="oriya-color2 font-size2 font-mbold font-normal m-0">
            Are you sure you want to disable the Parental Lock?
          </p>
        </div>
      </div>
      <div class="edit w-100 text-center margin-bottom-40 padding-top-12 padding-right-48 padding-left-48 parental-group-button">
        <button
          type="submit"
          class="text-uppercase font-mbold login_sub_btn"
          (click)="disableParentalLock()">
          Yes Disable ..!
        </button>
        <button
          class="low-prior-cancel margin-top-10"
          (click)="closeConfirmationPopup()">
          No
        </button>
      </div>
      <p class="parental-alert">Note: By Clicking Yes. Disable Explicit content will apppear in your feed</p>
    </div>
  </div>
</div>
 <!-- Parental lock ends -->
 <!-- Activate TV Popup -->
 <div class="modal cdk-overlay-dark-backdrop" id="activate-tv" style="display: none;">
  <div class="modal-dialog">
    <div class="modal-content user_flow">
      <div>
        <h4 class="activate-tv-text mt-4">Activate TV</h4>
        <p class="oriya-color2 font-size2 font-mbold text-center">Enter the code shown in your tv to activate</p>
        <div class="p-4 active-box" *ngIf="session">
            <p class="active-tv-desc margin-left-20 small-heading-color">Enter the 6 digit code</p>
            <form #verifyTokenForm="ngForm" [formGroup]="verifyToken">
              <div class="margin-left-20">
                <input formControlName="in1" class="tvVeri" matInput type="text" class="mr-2" inputmode="text" maxlength="1" (keyup)="keytabTV($event)" id="reg-otp-input" placeholder="0" (keypress)="numbCharOnly($event)" autocomplete="off"/>
                <input formControlName="in2" class="tvVeri" matInput type="text" class="mr-2" inputmode="text" maxlength="1" (keyup)="keytabTV($event)" id="reg-otp-input" placeholder="0" (keypress)="numbCharOnly($event)" autocomplete="off"/>
                <input formControlName="in3" class="tvVeri" matInput type="text" class="mr-2" inputmode="text" maxlength="1" (keyup)="keytabTV($event)" id="reg-otp-input" placeholder="0" (keypress)="numbCharOnly($event)" autocomplete="off"/>
                <input formControlName="in4" class="tvVeri" matInput type="text" class="mr-2" inputmode="text" maxlength="1" (keyup)="keytabTV($event)" id="reg-otp-input" placeholder="0" (keypress)="numbCharOnly($event)" autocomplete="off"/>
                <input formControlName="in5" class="tvVeri" matInput type="text" class="mr-2" inputmode="text" maxlength="1" (keyup)="keytabTV($event)" id="reg-otp-input" placeholder="0" (keypress)="numbCharOnly($event)" autocomplete="off"/>
                <input formControlName="in6" class="tvVeri" matInput type="text" class="mr-2" inputmode="text" maxlength="1" (keyup)="keytabTV($event)" id="reg-otp-input" placeholder="0" (keypress)="numbCharOnly($event)"autocomplete="off"/>
                <br>
              </div>
                <div class="margin-bottom-30 text-center pt-5 relative-content">
                <mat-error *ngIf="errorFlag" style="color:#F5841F;line-height: 30px;" class="margin-top-10 text-center error-desc">{{errorMessage}}</mat-error>
                <p *ngIf="successFlag" class="oriya-color successMsg margin-bottom-10">Activated Successfully</p>
                  <button 
                    (click)="closePop('logoutform')"
                    class="low-prior-cancel"
                    matSuffix>
                    Cancel
                  </button>
                  <button 
                    (click)="verifyCode()"
                    class="login_sub_btn margin-left-20"
                    [ngClass]="{'disabled': disableActivate}"
                    #matSuffix>
                    Activate
                  </button>
                </div>
                <p class="oriya-color2 font-size2 font-mbold m-0 margin-top-30 text-center">Once you enter the activation code</p>
                  <p class="oriya-color2 font-size2 font-mbold text-center">& click "ACTIVATE" can stream seamlessly in TV</p>
            </form>  
        </div>
        <div class="border p-4 active-box" *ngIf="!session">
            <p class="oriya-color1 mt-3 text-center">Please Login to Activate</p>
        </div>
      </div>
    </div>
  </div>
</div>